<template>
  <div class="casino-page">
    <v-layout  class="page-layout">
      <v-flex class="main-column" :style="{paddingTop: headerHeight + 'px'}" ref="maincolumn">
        <resize-observer @notify="mainColumnResize" />
        <div class="page-content casino">

          <div class="casinopage" :class="[state, {'loggedIn': isLoggedIn}]">
            <!-- geolocation indicator for in progress and verified geolocation attempts-->
            <v-dialog persistent v-if="(geolocationMessage.errorCode === 'verify' && onLoginGeolocationProgress) && geolocationOnLogin && isLoggedIn && isGeoLocEnabled && !isOpenedFromWebView && !mobileBigAndBelow" v-model="showGeolocationDialog">
              <div v-if="geolocationSubmitInternalError && geolocationSubmitInternalError.exceptionType && geolocationSubmitInternalError.exceptionType === 'TechnicalException'" class="close-geolocation-dialog" @click="closeGeolocationDialog()">
              </div>
              <geolocation-indicator></geolocation-indicator>
            </v-dialog>
            <!-- geolocation indicator for failed geolocation attempts-->
            <geolocation-indicator v-if="geolocationMessage.errorCode !== 'verify' && !geolocationStatus && isLoggedIn && isGeoLocEnabled && !isOpenedFromWebView && !mobileBigAndBelow" :section="'casino'"></geolocation-indicator>
            <sports-menu-mobile v-if="mobileBigAndBelow" :casino-navigation-items="navigation" :navigation-section="null" class="casino"></sports-menu-mobile>
            <headlinesLight category="CasinoHeadlines" :tiles="headlineTiles"></headlinesLight>
            <div v-if="tabletAndAbove" class="casino_links casino_nav left-column sports-menu">
              <site-navigation v-if="navigation" :casino-navigation-items="navigation" :navigation-section="null" class="popular expand navigation casino_links"></site-navigation>
            </div>
            <router-view></router-view>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <casino-launcher-dialog v-if="casinoLauncherDialog"></casino-launcher-dialog>
     <!-- RTP pop-up -->
    <div class="tandc-popup-container" v-if="rtpPopup">
      <div class="tandc-popup-child rtp-popup">
        <div class="tandc-popup-content rtp-popup">
          <static-content class="tc-text" :staticcontentpath="`/static/static-content/${$i18n.locale}/RTP.html`" :isPopUp="true" :fullPath="true" :method="'html'"></static-content>
        </div>
        <div class="form-actions">
          <v-btn class="btn primary-btn rtp" @click="toggleRTP('close')">{{ $t('Account.JoinUs.Popup.Close') }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Screen from '@/components/mixins/Screen'
import Session from '@/components/mixins/Session'
import Branding from '@/components/mixins/Branding'
import GeoLocation from '@/components/mixins/GeoLocation'
import store from '@/store'
import config from '@/config'
import Casino from '@/components/mixins/Casino'

import SiteNavigation from '@/components/common/SiteNavigation'
import CasinoSearchBar from '@/components/igaming/partials/casinoSearch/casinoSearchBar.vue'
import HeadlinesLight from '@/components/sports/bettingoffer/headlinesLight.vue'
import CasinoLauncherDialog from '@/components/igaming/partials/casinoLauncherDialog.vue'
import SportsMenuMobile from '@/components/sports/bettingoffer/SportsMenuMobile'
import GeolocationIndicator from '@/components/common/GeolocationIndicator.vue'
import StaticContent from '@/components/common/StaticContent'

export default {
  name: 'CasinoLayout',

  mixins: [
    Screen,
    Branding,
    Casino,
    Session,
    GeoLocation
  ],

  components: {
    SportsMenuMobile,
    CasinoLauncherDialog,
    HeadlinesLight,
    CasinoSearchBar,
    SiteNavigation,
    GeolocationIndicator,
    StaticContent
  },
  data () {
    return {
      showGeolocationDialog: true,
      rtpPopup: false
    }
  },
  computed: {
    headerMessageState () {
      return store.getters['overlayState/getHeaderMessageState']
    },
    headerHeight () {
      return store.getters['screenState/getHeaderHeight']
    },
    accountSummaryFlow () {
      return window.ctsautoconf.ACCOUNT_SUMMARY_FLOW || false
    },
    state () {
      return config.app.autoconf.STATE
    },
    headlineTiles () {
      return window.ctsautoconf.HEADLINES_TILES || false
    },
    casinoLauncherDialog () {
      return store.getters['overlayState/getCasinoLauncherDialogState']
    },
    launchGameAfterLogin () {
      return store.getters['gap/getLaunchGameWithGameIdAfterLogin']
    },
    geolocationMessage () {
      return store.getters['overlayState/getGeolocationMessage']
    },
    onLoginGeolocationProgress () {
      return store.getters['getOnLoginGeolocationProgress']
    },
    geolocationSubmitInternalError () {
      return store.getters['getGeolocationInternalError']
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    RTPstate () {
      return store.getters['gap/getRTPstore']
    },
    geolocationOnLogin () {
      return store.getters['getGeolocationOnLogin']
    },
    geolocationStatus () {
      return this.isGeolocated
    },
    navigation () {
      return store.getters['gap/getNavigation']
    }
  },
  mounted () {
    this.mainColumnResize()
  },
  beforeMount () {
    store.dispatch('gap/fetchAllGames')
    store.dispatch('gap/fetchAllJackpots')
    store.dispatch('gap/fetchTopGames')
    store.dispatch('gap/fetchMarketingJackpots')
    store.dispatch('gap/fetchNavigation')
    if (this.isLoggedIn) {
      store.dispatch('gap/fetchUserRecentlyPlayedGames')
      store.dispatch('gap/fetchRecommendedGames')
      store.dispatch('gap/fetchAllFavoriteGames')
    }
  },

  methods: {
    mainColumnResize () {
      var mainColumn = this.$refs.maincolumn

      if (mainColumn) {
        store.commit('screenState/setMainColumnWidth', mainColumn.offsetWidth)
      }
    },
    closeGeolocationDialog () {
      store.commit('setTriggerBSLocationVerifiedAnimation', false)
      this.showGeolocationDialog = false
    },
    toggleRTP (param) {
      if (param === 'open') {
        this.rtpPopup = true
        let event = {
          'event': 'casino_game_rtp_explanation_opened',
          'gaEventAction': 'casino_game_rtp_explanation_opened',
          'gaGameId': this.RTPstate.gameId || 'N/A',
          'accountId': localStorage.customer || 'N/A'
        }
        let xtremeObj = {
          'param1': 'event',
          'param2': 'casino_game_rtp_explanation_opened',
          'param3': {
            'gaGameId': this.RTPstate.gameId || 'N/A',
            'accountId': localStorage.customer || 'N/A'
          }
        }
        this.updateAnalytics(event, xtremeObj)
      } else if (param === 'close') {
        this.rtpPopup = false
        store.commit('gap/setRTPstore', false)
      }
    }
  },

  watch: {
    '$route' () {
      this.userIsActive()
    },
    isGeolocated (newVal) {
      if (newVal) {
        if (this.launchGameAfterLogin) {
          setTimeout(() => {
            this.startCasinoLauncher(this.launchGameAfterLogin)
          }, 3000)
        }
      }
    },
    isLoggedIn (newVal) {
      if (newVal) {
        store.dispatch('gap/fetchUserRecentlyPlayedGames')
        store.dispatch('gap/fetchRecommendedGames')
        store.dispatch('gap/fetchAllFavoriteGames')
      }
    },
    RTPstate (newVal) {
      if (newVal) {
        this.toggleRTP(this.RTPstate.param)
      }
    }
  },

  created () {}
}
</script>

<style lang="stylus" scoped>
.close-geolocation-dialog
  background-image: var(--casino-dialog-close-icon)
  width: 25px
  display: block
  height: 25px
  margin-left: auto
  cursor: pointer
.casino_links.casino_nav
  padding 0 !important
  .site-navigation.casino_links
    background: none !important
    box-shadow: none !important
    >>>ul.navigation
      display flex
      align-items center
      // justify-content center
      gap 15px
      overflow auto
      scrollbar-width none
      li.navigation-item
        min-width 150px
        height 38px
        background #262332
        border-bottom none
        padding: 2px 5px
        border-radius: 6px;
        &:hover
          background: #4D495C
        &:has(.router-link-exact-active)
          background: #4D495C
      li.navigation-item a
        color: rgba(255, 255, 255, 0.80) !important
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width 100%
</style>



// WEBPACK FOOTER //
// src/components/layout/CasinoLayout.vue